<script setup>
const content =
  'De schaal Structuur gaat over hoe u uw werk organiseert en aanpakt. <br>Iemand die hoog scoort op deze schaal werkt planmatig en gedisciplineerd. Hij/zij denkt vooruit en houdt ervan aan patronen vast te houden. <br>Mensen die op deze schaal laag scoren zijn impulsiever en minder volhardend. Zij zijn hierdoor flexibeler en kunnen goed omgaan met veranderingen.'
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
